import { createContext, ReactNode, useContext } from 'react';
import { DEBUG } from '../constants';

// Create debug context
export const DebugContext = createContext(true);

// Hook to easily use debug context
export const useDebugContext = () => useContext(DebugContext);

// Provider component for debug context
export const DebugProvider = ({ children }: { children: ReactNode }) => {
  return <DebugContext.Provider value={DEBUG}>{children}</DebugContext.Provider>;
};
